import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { background, navigation, titles } from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';

const { info, primary } = THEME.colors;

export const styleSheet = StyleSheet.create({
	infoField: {
		':not(:last-child)': {
			marginBottom: 20,
		},
		marginBottom: 0,
	},
	infoFieldContainer: {
		marginBottom: 20,
	},
	infoFieldEditing: {
		marginBottom: 35,
	},
	infoFieldLabel: {
		alignItems: 'center',
		color: navigation,
		display: 'flex',
		fontSize: 12,
		height: 17,
	},
	infoFieldValue: {
		color: titles,
		fontSize: 14,
		height: 30,
	},
	infoIcon: {
		marginLeft: 4,
		marginTop: 5,
	},
	infoMessage: {
		background,
		color: titles,
		fontSize: 12,
	},
	popover: {
		maxWidth: 300,
	},
	infoFieldLabelNewIcon: {
		backgroundColor: info.main,
		borderRadius: THEME.common.borderRadius,
		fontSize: 11,
		color: primary.contrastText,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: `2px 4px`,
		gap: THEME.spacing.xs,
		marginRight: THEME.spacing.xs,

		...CssSelectors.allChildren(
			{
				width: 10,
				height: 10,
			},
			'svg'
		),
	},
});
